import { QUERY_GET_FACTORY_CASES_BY_PLATE} from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getFactoryCasesByPlate = baseThunk(`factoryCases/getByPlate`, QUERY_GET_FACTORY_CASES_BY_PLATE, "GET")
export const refreshFactoryCasesByPlate = baseThunk(`factoryCases/refreshByPlate`, QUERY_GET_FACTORY_CASES_BY_PLATE, "GET")